const recipientLabelCache = new Map<string, string>();

export const getCachedEmailRecipientLabel = (userId: string): string | undefined => {
	return recipientLabelCache.get(userId);
};

export const cacheEmailRecipientLabel = (userId: string, label: string): void => {
	recipientLabelCache.set(userId, label);
};

export const cacheEmailRecipientLabels = (labelsById: Map<string, string>): void => {
	labelsById.forEach((label, userId) => {
		recipientLabelCache.set(userId, label);
	});
};

export const getEmailRecipientLabelCacheSnapshot = (): Map<string, string> => {
	return new Map(recipientLabelCache);
};

export const clearEmailRecipientLabelCacheForTests = (): void => {
	recipientLabelCache.clear();
};
